export function hslColorFromName(name: string, saturation = 70, lightness = 50): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  
  return `hsl(${hash % 360}, ${saturation}%, ${lightness}%)`;
}